import { NestedResourceNode, ResourceAction } from "@legacy-megarax/rest-resource";

export default NestedResourceNode("maintenance", {
  rebuildIndices: ResourceAction({
    name: "maintenance.rebuildIndices",
    path: "rebuildIndices",
    method: "post",
  }),
});
